import { find } from '../helpers';

const element = find('[data-map-type]')

if (element && element.dataset.mapType && element.dataset.mapType === 'offices') {
    import(/* webpackChunkName: "maps" */'./index')
}
